import { PURE_BLACK } from '../../constants';

export const customTooltipStyles = {
  tooltipmsg: {
    cursor: 'pointer',
    position: 'relative',
    top: '2px',
  },

  tooltip: {
    color: PURE_BLACK,
    borderRadius: '10px',
    maxWidth: '280px',
    width: 'fit-content',
    padding: '8px 11px',
    font: 'normal normal 400 13px/14px Arial',
    letterSpacing: '0.09px',
    lineHeight: '16px',
    opacity: 1,
    background: '#F4EDF4',
  },

  tooltipBundle: {
    borderRadius: '8px',
    padding: '8px',
    background: '#F5E9F5',
    font: 'normal normal 400 12px/120% Arial',
    letterSpacing: '0px',
    color: PURE_BLACK,
    opacity: 1,
  },

  // Uncomment and complete if needed
  // arrow: {
  //   fontSize: 18,
  //   width: 20,
  //   '&::before': {
  //     border: `0.5px solid ${ORIENTAL_ORANGE}`,
  //     backgroundColor: SEASHELL_COLOR,
  //     boxSizing: 'border-box',
  //   },
  // },
};
